import { IDataListURLFields } from "shared/components/dataListURL/types";
import { LineItem } from "../types";
import { StringParam } from "use-query-params";
import { onFilterBy, compareStringBy } from "utils/helpers.table";
import { dateFilterFn, displayDate } from "../helpers";

export const fields: IDataListURLFields<keyof LineItem, LineItem> = {
  name: {
    filterFn: onFilterBy("name", {
      matchMode: "includes",
      caseInsensitive: true,
    }),
    sorterFn: compareStringBy("name"),
    queryParamConfigFilter: StringParam,
  },
  startDate: {
    filterFn: dateFilterFn("startDate"),
    sorterFn: compareStringBy("startDate"),
    queryParamConfigFilter: StringParam,
    display: displayDate,
  },
  endDate: {
    filterFn: dateFilterFn("endDate"),
    sorterFn: compareStringBy("endDate"),
    queryParamConfigFilter: StringParam,
    display: displayDate,
  },
};

export const fieldKeys = Object.keys(fields) as Array<keyof typeof fields>;
